"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class for handling user flow events.
 */
class FlowHandler {
    constructor() {
        this.flows = [];
    }
    /**
     * Get a user flow by name.
     *
     * @param flowName
     */
    getFlow(flowName) {
        return this.flows.find(f => f.flowName == flowName);
    }
    /**
     * Create a new flow.
     *
     * @param flowName
     * @param stepName
     * @param stepLevel
     */
    createFlow(flowName, stepName, stepLevel) {
        const flow = this.flows.find(f => f.flowName == flowName);
        if (flow === undefined) {
            const newFlow = {
                flowName: flowName,
                stepName: stepName,
                stepLevel: stepLevel
            };
            this.flows.push(newFlow);
        }
    }
    /**
     * Update a flow.
     *
     * @param flowName
     * @param stepName
     * @param stepLevel
     */
    updateFlow(flowName, stepName, stepLevel) {
        const flowIndex = this.flows.map(f => f.flowName).indexOf(flowName);
        if (flowIndex === -1) {
            this.createFlow(flowName, stepName, stepLevel);
        }
        else {
            this.flows[flowIndex] = {
                flowName: flowName,
                stepName: stepName,
                stepLevel: stepLevel
            };
        }
    }
    /**
     * Delete a flow.
     *
     * @param flowName
     */
    deleteFlow(flowName) {
        const flowIndex = this.flows.map(f => f.flowName).indexOf(flowName);
        if (flowIndex !== -1) {
            this.flows.splice(flowIndex, 1);
        }
    }
}
exports.default = FlowHandler;
//# sourceMappingURL=FlowHandler.js.map